import { render, staticRenderFns } from "./FeaturesCarousel.vue?vue&type=template&id=48e12706"
import script from "./FeaturesCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturesCarousel.vue?vue&type=script&lang=js"
import style0 from "./FeaturesCarousel.vue?vue&type=style&index=0&id=48e12706&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports